export default "__VITE_PUBLIC_ASSET__842205cf__"